import { useState } from 'react';
import PropTypes from 'prop-types';
import CloseIcon from '../../../assets/icons/close.svg?react';

const SaveConfirmModal = ({ onClose, onConfirm }) => {
  const [isPending, setIsPending] = useState(false);

  const handleConfirm = async () => {
    setIsPending(true);
    try {
      await onConfirm();
      onClose();
    } catch (error) {
      console.error('역할 권한 설정 저장 실패:', error);
      alert('역할 권한 설정 저장에 실패했습니다.');
    } finally {
      setIsPending(false);
    }
  };

  return (
    <div className="modal-background" onClick={onClose}>
      <div className="modal-container" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h3 className="text-h3 text-gray-900">역할 권한 설정 저장 확인</h3>
          <button 
            className="close-btn"
            onClick={onClose}
          >
            <CloseIcon />
          </button>
        </div>
        
        <div className="modal-content">
          <p className="text-b2-400 text-gray-700">
            변경된 역할 권한 설정을 저장하시겠습니까?
          </p>
          <p className="text-b3-400 text-gray-700 mt-10">
            저장 완료 후 <u>변경된 역할을 가진 계정</u>은 <span className="text-red-500">재로그인</span> 해주세요.
          </p>

        </div>

        <div className="modal-footer">
          <button 
            className="btn py-5 px-10 big-btn btn-primary flex-1"
            onClick={handleConfirm}
            disabled={isPending}
          >
            {isPending ? '저장 중...' : '저장하기'}
          </button>
        </div>
      </div>
    </div>
  );
};

SaveConfirmModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
};

export default SaveConfirmModal;

